// Shared content width for all non-map pages: 80% on small screens, 70% on
// medium+ screens, centered horizontally.
export const contentWidthSx = {
  width: { xs: '80%', md: '70%' },
  mx: 'auto',
};
